import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { changePasswordApi, getCurrentUser } from "../apis/userApi";

export const useLoadUser = () => {
  return useQuery({
    queryKey: ["adminApi_user"],
    queryFn: () => getCurrentUser(),
    initialData: {},
    retry: false,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useChangePassword = (options = {}) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["change_password"],
    mutationFn: async (payload) => {
      return changePasswordApi(payload);
    },
    onSuccess() {
      qClient.invalidateQueries();
    },
  });
};
